function addtocartSuggestion(productId, note) {
    const variant = document.getElementById("variants_" + productId).value;
    const formData = {
        items: [{
            id: variant,
            quantity: 1,
        }],
        note: note,
    };

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then(carthtml => {
        fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
        .then(response => response.ok ? response.text() : Promise.reject('Failed to load'))
        .then(html => document.getElementById('cart-icon-bubble').innerHTML = html)
        .catch(console.error);

        fetch(`${window.Shopify.routes.root}?section_id=cart-notification-product`)
        .then(response => response.ok ? response.text() : Promise.reject('Failed to load'))
        .then(html => document.getElementById('cart-item').innerHTML = html)
        .catch(console.error);

        new CartNotification().open();
    })
    .catch(error => {
        console.error('Error:', error);
    });
}